/* @flow */

import { black, white } from '@e180/ui/lib/token/palette';
import { highlightedInputFontFamily } from '@e180/ui/lib/token/typography';

export default {
  'root-isHighlighted': {
    padding: '0.5em',

    backgroundColor: [white, '!important'],
    borderRadius: 4,
    color: black,

    fontFamily: highlightedInputFontFamily,
    fontSize: 22,
    lineHeight: 1.1,

    '&::placeholder': {
      color: '#747476',

      fontStyle: 'normal',
      WebkitFontSmoothing: 'antialiased',
    },
  },
};
